"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _components = require("@/components");
var _branch = require("@/api/data/branch");
var _user = require("@/api/data/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Menu',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      listData: [],
      isEdit: false,
      dialogVisible: false,
      dataForm: {
        id: '',
        name: '',
        pid: '',
        user: [],
        state: 1
      },
      tempData: {},
      userList: [],
      rules: {
        name: [{
          required: true,
          message: '请输入name',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getUserSelection();
    this.fetchData();
  },
  methods: {
    getUserSelection: function getUserSelection() {
      var _this = this;
      (0, _user.getUserSelectList)().then(function (res) {
        _this.userList = Object.keys(res.data.list).map(function (item) {
          return {
            id: Number(item),
            real_name: res.data.list[item]
          };
        });
      });
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _branch.getBranchList)();
            case 2:
              res = _context.sent;
              this.listData = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    addBranchBtn: function addBranchBtn() {
      var pid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.isEdit = false;
      this.dialogVisible = true;
      this.dataForm = {
        pid: pid,
        name: '',
        user: [],
        state: 1
      };
    },
    deleteBranchBtn: function () {
      var _deleteBranchBtn = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(id) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$confirm('是否删除', {
                confirmButtonText: '',
                cancelButtonText: '',
                type: 'warning'
              });
            case 3:
              _context2.next = 5;
              return (0, _branch.deleteBranch)(id);
            case 5:
              this.fetchData();
              _context2.next = 12;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.log('err', _context2.t0);
              if (_context2.t0 === 'cancel') {
                this.$message.warning('取消删除');
              } else {
                this.$message.error(_context2.t0);
              }
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function deleteBranchBtn(_x) {
        return _deleteBranchBtn.apply(this, arguments);
      }
      return deleteBranchBtn;
    }(),
    tableEdit: function () {
      var _tableEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.tempData = data;
              this.isEdit = true;
              this.dataForm = {
                id: data.id,
                name: data.name,
                pid: data.pid,
                user: data.user.map(function (item) {
                  return item.uid;
                }),
                state: data.state
              };
              this.dialogVisible = true;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function tableEdit(_x2) {
        return _tableEdit.apply(this, arguments);
      }
      return tableEdit;
    }(),
    onSave: function onSave(event, tempData) {
      var _this2 = this;
      this.$refs['branchForm'].validate(function (valid) {
        if (!valid) {
          throw new Error('error submit!!');
        }
      });
      if (!tempData) tempData = this.tempData;
      if (!this.isEdit) {
        (0, _branch.addBranch)(this.dataForm).then(function (res) {
          _this2.$message.success('添加成功');
          _this2.fetchData();
        }).catch(function (err) {
          _this2.$message.error(err.msg);
        });
      } else {
        (0, _branch.updateBranch)(this.dataForm).then(function (res) {
          _this2.$message.success('编辑成功');
          if (_this2.dataForm.state === 0 && tempData.children && tempData.children.length > 0) {
            var _iterator = (0, _createForOfIteratorHelper2.default)(tempData.children),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;
                tempData = item;
                _this2.dataForm = {
                  id: item.id,
                  pid: item.pid,
                  name: item.name,
                  user: item.user.map(function (i) {
                    return i.id;
                  }),
                  state: 0
                };
                _this2.onSave(event, tempData);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            _this2.fetchData();
          }
        }).catch(function (err) {
          _this2.$message.error(err.msg);
        });
      }
      this.dialogVisible = false;
    },
    resetForm: function resetForm() {
      this.$refs['branchForm'].resetFields();
      this.dialogVisible = false;
    }
  }
};
exports.default = _default;